const ANALISE_FRAUDE_APROVADA = 'ANALISE_FRAUDE_APROVADA';
const FINALIZADA_COM_SUCESSO = 'FINALIZADA_COM_SUCESSO';
const DADOS_PAGAMENTO_NAO_VALIDADO_MANTER_DADOS =
  'DADOS_PAGAMENTO_NAO_VALIDADO_MANTER_DADOS';
const FALHA_VALIDAR_BIN_COM_CODIGO_PROMOCIONAL =
  'FALHA_VALIDAR_BIN_COM_CODIGO_PROMOCIONAL';

export {
  ANALISE_FRAUDE_APROVADA,
  FINALIZADA_COM_SUCESSO,
  DADOS_PAGAMENTO_NAO_VALIDADO_MANTER_DADOS,
  FALHA_VALIDAR_BIN_COM_CODIGO_PROMOCIONAL,
};
